import React from 'react';

const usePagination = (items, itemsPerPage) => {
  const [itemsDisplaying, setItemsDisplaying] = React.useState(itemsPerPage);

  const handleNext = () => {
    if (itemsDisplaying < items.length) {
      setItemsDisplaying(itemsDisplaying + itemsPerPage);
    }
  };

  const handlePrevious = () => {
    if (itemsDisplaying > 0) {
      setItemsDisplaying(itemsDisplaying - itemsPerPage);
    }
  };

  return {
    handleNext,
    handlePrevious,
    itemsDisplaying,
  };
};

export default usePagination;
